import { motion } from "framer-motion";

const imagesRow1 = [
  "/images/img1.jpeg",
  "/images/img2.jpeg",
  "/images/img3.jpeg",
  "/images/img4.jpeg",
  "/images/img5.jpeg",
  "/images/img11.jpeg",
  "/images/img12.jpeg",
  "/images/img13.jpeg",
  "/images/img14.jpeg",
  "/images/img15.jpeg",
  "/images/img0.jpeg",
];

const imagesRow2 = [
  "/images/img6.jpeg",
  "/images/img7.jpeg",
  "/images/img8.jpeg",
  "/images/img9.jpeg",
  "/images/img10.jpeg",
  "/images/img16.jpeg",
  "/images/img17.jpeg",
  "/images/img18.jpeg",
  "/images/img19.jpeg",
  "/images/img20.jpeg",
];

function MovingRow({ images, direction = "left", speed = 40 }) {
  return (
    <motion.div
      className="flex gap-4 sm:gap-6 lg:gap-8 w-max"
      animate={{
        x: direction === "left" ? ["0%", "-50%"] : ["-50%", "0%"],
      }}
      transition={{
        repeat: Infinity,
        repeatType: "loop",
        duration: speed,
        ease: "linear",
      }}
    >
      {[...images, ...images].map((img, i) => (
        <motion.div
          key={i}
          whileHover={{
            scale: 1.05,
            boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
          }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.3 }}
          className="relative h-40 w-56 sm:h-48 sm:w-72 lg:h-56 lg:w-80 rounded-2xl lg:rounded-3xl overflow-hidden shadow-lg bg-white cursor-pointer border border-gray-300 flex-shrink-0"
        >
          <img
            src={img}
            alt="Ekamdhyas memory"
            className="w-full h-full object-cover"
          />
        </motion.div>
      ))}
    </motion.div>
  );
}

export default function Gallery() {
  return (
    <section className="bg-white overflow-hidden py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-[#0b1b4d]">
            Moments & Memories
          </h2>

          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="h-1 w-20 rounded-full bg-indigo-600" />
            <span className="h-1 w-3 rounded-full bg-indigo-300" />
          </div>

          <p className="mt-4 sm:mt-6 text-sm sm:text-base text-gray-600 max-w-xl mx-auto leading-relaxed">
            A glimpse into workshops, learning sessions, internships, and the
            experiences we've built together.
          </p>
        </div>

        <div className="space-y-8 sm:space-y-12">
          <div className="overflow-hidden">
            <MovingRow images={imagesRow1} direction="left" speed={45} />
          </div>

          <div className="overflow-hidden">
            <MovingRow images={imagesRow2} direction="right" speed={50} />
          </div>
        </div>
      </div>
    </section>
  );
}
